import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

const LOGO = "/logo.png";

export default function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/auth/forgot-password", { username });
      setSent(res.data.message);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream px-6">
      <div className="w-full max-w-md">
        <img src={LOGO} alt="Dermatrix" className="mb-8 h-12 object-contain" />
        <h1 className="font-display text-3xl font-semibold text-navy">Forgot password</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Enter your username and we'll email you a reset link.
        </p>

        {sent ? (
          <div className="mt-6 flex items-start gap-3 rounded-lg bg-white p-4 shadow-sm" data-testid="forgot-sent">
            <MailCheck className="mt-0.5 h-5 w-5 shrink-0 text-gold" />
            <p className="text-sm text-ink">{sent}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-5" data-testid="forgot-form">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-ink">Username</Label>
              <Input id="username" value={username} onChange={(e) => setUsername(e.target.value.replace(/\s/g, ""))}
                data-testid="forgot-username" required className="h-11 bg-white" placeholder="Email, phone, or ID" />
            </div>
            {error && (
              <div className="rounded-lg bg-red-50 px-4 py-3 text-sm font-medium text-red-700" data-testid="forgot-error">
                {error}
              </div>
            )}
            <Button type="submit" disabled={loading} data-testid="forgot-submit"
              className="h-11 w-full bg-navy text-white hover:bg-navy-hover">
              {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Sending…</> : "Send reset link"}
            </Button>
          </form>
        )}

        <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-navy hover:underline" data-testid="back-to-login">
          <ArrowLeft className="h-4 w-4" /> Back to sign in
        </Link>
      </div>
    </div>
  );
}
